import { all, put, takeLatest, call } from 'redux-saga/effects'
import * as actionTypes from './action-types'
import * as actionTypesError from '../errors/action-types'
import { fetchHome } from './api'

function* homeSaga() {
  try {
    const response = yield call(fetchHome)
    yield put({ type: actionTypes.HOME_SUCCESS })
    yield put({ type: actionTypes.SET_HOME_INFORMATION, payload: response })
  } catch (e) {
    yield put({ type: actionTypes.HOME_ERROR })
    yield put({ type: actionTypesError.ERROR, payload: { error: e } })
  }
}

export default function* rootSaga() {
  yield all([takeLatest(actionTypes.HOME, homeSaga)])
}
